require('jquery');

$(() =>
{
    $('.card.clickable[data-href]')
        .on('click', (e) =>
        {
            // noinspection JSUnresolvedFunction
	        e.openTargetLink();
            e.preventDefault();
        });
});
